import { render, staticRenderFns } from "./kpTableItem.vue?vue&type=template&id=7f8b3e0b&scoped=true&"
import script from "./kpTableItem.vue?vue&type=script&lang=ts&"
export * from "./kpTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./kpTableItem.vue?vue&type=style&index=0&id=7f8b3e0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b3e0b",
  null
  
)

export default component.exports